export default "__VITE_ASSET__CZxiEHhe__"